// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8429e574","239":"dfdb0d71","455":"b06868b9","488":"ff707169","762":"dccc01f6"}[chunkId] + ".chunk.js";
};